<template>
  <main class="main payment-fail-page">
    <section class="payment-fail">
      <div class="payment-fail__container">
        <div class="payment-fail__icon">
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M8 8L26 26"
              stroke="#160909"
              stroke-width="5"
              stroke-linecap="square"
            />
            <path
              d="M26 8L8 26"
              stroke="#160909"
              stroke-width="5"
              stroke-linecap="square"
            />
          </svg>
        </div>

        <h1 class="payment-fail__title">
          {{ $t('Оплата не прошла') }}
        </h1>

        <p class="payment-fail__description">
          {{ $t('К сожалению, нам не удалось обработать ваш платёж.') }}
        </p>

        <p class="payment-fail__meta">
          {{
            $t('Проверьте данные карты или попробуйте повторить оплату позже.')
          }}
        </p>

        <div
          v-if="supportEmail"
          class="payment-fail__meta payment-fail__meta_last"
        >
          <span> {{ $t('Если у вас возникнут вопросы, напишите нам:') }}</span>
          <a :href="`mailto:${supportEmail}`" class="payment-fail__email">
            {{ supportEmail }}
          </a>
        </div>

        <div class="payment-fail__actions">
          <button
            type="button"
            class="button shadowed payment-fail__secondary"
            @click="$router.push({ path: '/categories' })"
          >
            <span>{{ $t('В ЛАВКУ') }}</span>
          </button>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'PaymentFaliPage',
  props: [],
  components: {},
  data: function () {
    return {}
  },
  computed: {
    supportEmail() {
      return (
        (this.$parent.settings && this.$parent.settings.support_email) || ''
      )
    },
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.payment-fail-page {
  position: relative;
  overflow: hidden;
}

.payment-fail {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 70px 16px 100px;
}

.payment-fail__container {
  width: 100%;
  max-width: 720px;

  display: flex;
  align-items: center;
  flex-direction: column;

  text-align: center;
}

.payment-fail__icon {
  position: relative;

  width: 95px;
  height: 95px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: #e05d62;

  box-shadow: inset 0 -10px 0 rgba(0, 0, 0, 0.24),
    inset -10px 0 0 rgba(0, 0, 0, 0.24),
    inset 0 10px 0 rgba(255, 255, 255, 0.18),
    inset 10px 0 0 rgba(255, 255, 255, 0.18);

  svg {
    width: 34px;
    height: 34px;
  }
}

.payment-fail__title {
  margin-top: 26px;

  font-family: var(--font-2);
  font-size: 36px;
  font-weight: 700;
  line-height: 120%;

  color: var(--gray-nurse);
}

.payment-fail__description {
  max-width: 580px;
  margin-top: 15px;

  font-family: var(--font-1);
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;

  color: var(--gray-nurse);
}

.payment-fail__meta {
  max-width: 560px;
  margin-top: 15px;

  font-family: var(--font-1);
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;

  color: var(--mantle);
  &_last {
    margin-top: 7px;
  }
}

.payment-fail__email {
  color: var(--mantle);
  text-decoration: none;
  text-decoration: underline;
  transition: color 0.3s ease;

  @media (any-hover: hover) {
    &:hover {
      color: var(--mountain-meadow);
    }
  }
}

.payment-fail__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 14px;

  margin-top: 36px;
}

.payment-fail__primary,
.payment-fail__secondary {
  min-height: 40px;
  justify-content: center;
  margin: 0;
  padding: 12px 23px;

  font-family: var(--font-3);
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
}

.payment-fail__primary {
  min-width: 204px;
}

.payment-fail__secondary {
  min-width: 122px;
}

@media (max-width: 767.98px) {
  .payment-fail {
    padding: 25px 16px 75px;
  }

  .payment-fail__icon {
    width: 72px;
    height: 72px;

    svg {
      width: 29px;
      height: 29px;
    }
  }

  .payment-fail__title {
    margin-top: 25px;
    font-size: 27px;
    line-height: 36px;
  }

  .payment-fail__description,
  .payment-fail__meta {
    font-size: 14px;
    line-height: 130%;
  }
}

@media (max-width: 480px) {
  .payment-fail__actions {
    width: 100%;
    flex-direction: column;
  }

  .payment-fail__primary,
  .payment-fail__secondary {
    width: 100%;
  }

  .payment-fail__description,
  .payment-fail__meta {
    max-width: 320px;
  }
}
</style>
